import React, { useState } from 'react';
import { ChatConversation } from '../../components/ChatConversation';
import { UserPlus2Icon, Users2Icon, PlayIcon, MessageSquareIcon } from 'lucide-react';
export function Lobby({
  onStartGame
}) {
  const [team, setTeam] = useState([{
    id: 1,
    name: 'You',
    role: '',
    skills: [],
    avatar: '👤',
    isCurrentUser: true
  }]);
  const [showChat, setShowChat] = useState(true);
  const [activeTab, setActiveTab] = useState('lobby');
  // Mock data for available games
  const availableGames = [{
    id: 1,
    name: 'Tech Innovators',
    players: 3,
    status: 'waiting'
  }, {
    id: 2,
    name: 'Healthcare Solutions',
    players: 4,
    status: 'in progress'
  }, {
    id: 3,
    name: 'Green Energy Startup',
    players: 2,
    status: 'waiting'
  }];
  // Mock data for game history
  const gameHistory = [{
    id: 101,
    name: 'EdTech Revolution',
    date: '2023-09-15',
    result: 'Completed',
    team: 4
  }, {
    id: 102,
    name: 'Fintech App',
    date: '2023-08-22',
    result: 'Abandoned',
    team: 3
  }];
  const addTeamMember = member => {
    if (team.length < 4) {
      setTeam([...team, {
        id: Date.now(),
        name: member.name,
        role: member.role || '',
        skills: member.skills || [],
        avatar: member.avatar || '👤',
        isCurrentUser: false
      }]);
    }
  };
  const removeTeamMember = id => {
    setTeam(team.filter(member => member.id !== id));
  };
  const startGame = () => {
    if (team.length >= 2) {
      onStartGame(team);
    }
  };
  const handleConversationSave = conversation => {
    // Extract potential team members from conversation
    // This is a simplified example - in a real app, you'd use more sophisticated NLP
    const lastMessage = conversation[conversation.length - 1];
    if (lastMessage && lastMessage.content.toLowerCase().includes('join team')) {
      const name = lastMessage.content.split('join team')[0].trim();
      addTeamMember({
        name,
        role: 'Undecided',
        skills: ['Communication'],
        avatar: '👤'
      });
    }
  };
  return <div className="w-full min-h-screen p-4 md:p-6" data-id="element-265">
      <header className="mb-6 text-center" data-id="element-266">
        <h1 className="text-3xl md:text-4xl font-bold text-indigo-800" data-id="element-267">
          Bridges of Life
        </h1>
        <p className="text-lg text-indigo-600" data-id="element-268">
          Build your startup dream team and bring your ideas to life
        </p>
      </header>
      <div className="flex flex-col md:flex-row gap-6" data-id="element-269">
        <div className="w-full md:w-2/3 bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-270">
          <div className="border-b border-gray-200" data-id="element-271">
            <nav className="flex" data-id="element-272">
              <button className={`px-4 py-3 text-sm font-medium ${activeTab === 'lobby' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('lobby')} data-id="element-273">
                Lobby
              </button>
              <button className={`px-4 py-3 text-sm font-medium ${activeTab === 'history' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('history')} data-id="element-274">
                Game History
              </button>
            </nav>
          </div>
          {activeTab === 'lobby' && <div className="p-4" data-id="element-275">
              <h2 className="text-xl font-semibold mb-4" data-id="element-276">Available Games</h2>
              <div className="space-y-3" data-id="element-277">
                {availableGames.map(game => <div key={game.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100" data-id="element-278">
                    <div data-id="element-279">
                      <h3 className="font-medium" data-id="element-280">{game.name}</h3>
                      <p className="text-sm text-gray-500" data-id="element-281">
                        <Users2Icon className="inline w-4 h-4 mr-1" data-id="element-282" />{' '}
                        {game.players} players
                      </p>
                    </div>
                    <div className="flex items-center" data-id="element-283">
                      <span className={`px-2 py-1 text-xs rounded-full mr-3 ${game.status === 'waiting' ? 'bg-green-100 text-green-800' : game.status === 'in progress' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-284">
                        {game.status}
                      </span>
                      <button className={`px-3 py-1 text-sm rounded-md ${game.status === 'waiting' ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-gray-200 text-gray-500 cursor-not-allowed'}`} disabled={game.status !== 'waiting'} data-id="element-285">
                        Join
                      </button>
                    </div>
                  </div>)}
              </div>
              <div className="mt-6" data-id="element-286">
                <button className="w-full py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition flex items-center justify-center" onClick={startGame} data-id="element-287">
                  <PlayIcon className="w-4 h-4 mr-2" data-id="element-288" />
                  Start New Game
                </button>
              </div>
            </div>}
          {activeTab === 'history' && <div className="p-4" data-id="element-289">
              <h2 className="text-xl font-semibold mb-4" data-id="element-290">Your Game History</h2>
              {gameHistory.length > 0 ? <div className="space-y-3" data-id="element-291">
                  {gameHistory.map(game => <div key={game.id} className="p-3 bg-gray-50 rounded-lg" data-id="element-292">
                      <h3 className="font-medium" data-id="element-293">{game.name}</h3>
                      <div className="flex justify-between text-sm text-gray-500 mt-1" data-id="element-294">
                        <span data-id="element-295">Date: {game.date}</span>
                        <span data-id="element-296">Team size: {game.team}</span>
                        <span className={`${game.result === 'Completed' ? 'text-green-600' : 'text-amber-600'}`} data-id="element-297">
                          {game.result}
                        </span>
                      </div>
                    </div>)}
                </div> : <p className="text-center text-gray-500 py-8" data-id="element-298">
                  No game history yet. Start playing to create your journey!
                </p>}
            </div>}
        </div>
        <div className="w-full md:w-1/3 flex flex-col gap-6" data-id="element-299">
          <div className="bg-white rounded-xl shadow-lg p-4" data-id="element-300">
            <h2 className="text-xl font-semibold mb-4" data-id="element-301">
              Your Team ({team.length}/4)
            </h2>
            {team.length > 0 ? <div className="space-y-3" data-id="element-302">
                {team.map(member => <div key={member.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-303">
                    <div className="flex items-center" data-id="element-304">
                      <div className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center text-xl" data-id="element-305">
                        {member.avatar}
                      </div>
                      <div className="ml-3" data-id="element-306">
                        <h3 className="font-medium" data-id="element-307">{member.name}</h3>
                        <p className="text-xs text-gray-500" data-id="element-308">
                          {member.role || 'No role assigned'}
                        </p>
                      </div>
                    </div>
                    {!member.isCurrentUser && <button className="text-red-500 hover:text-red-700" onClick={() => removeTeamMember(member.id)} data-id="element-309">
                        Remove
                      </button>}
                  </div>)}
              </div> : <p className="text-center text-gray-500 py-4" data-id="element-310">
                No team members yet. Add members to start!
              </p>}
            <div className="mt-4" data-id="element-311">
              <button className={`w-full py-2 rounded-md transition flex items-center justify-center ${team.length >= 4 ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-indigo-600 text-white hover:bg-indigo-700'}`} disabled={team.length >= 4} onClick={() => setShowChat(true)} data-id="element-312">
                <UserPlus2Icon className="w-4 h-4 mr-2" data-id="element-313" />
                Find Team Members
              </button>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg overflow-hidden" data-id="element-314">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-315">
              <h2 className="text-xl font-semibold" data-id="element-316">Chat Lobby</h2>
              <button className="text-indigo-600 hover:text-indigo-800" onClick={() => setShowChat(!showChat)} data-id="element-317">
                <MessageSquareIcon className="w-5 h-5" data-id="element-318" />
              </button>
            </div>
            {showChat && <div className="h-96" data-id="element-319">
                <ChatConversation systemPrompt="You are a helpful assistant in the Bridges of Life game lobby. Help players find team members with complementary skills for their startup. When a player says they want to join a team, respond positively and help facilitate the connection." onConversationSave={handleConversationSave} data-id="lobby-chat" />
              </div>}
          </div>
        </div>
      </div>
    </div>;
}